import axios from 'axios'
import { exportAxios } from '@/utils/axiosType'

export default {
  // 节点机列表列表
  getNodeList (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeList', params)
  },
  // 查询全部节点机ID列表接口
  selectAllNodeIdList (params) {
    return axios.post('/api/rendering/admin/task/node/selectAllNodeIdList', params)
  },
  // 节点机各种状态统计数据
  getNodeStatistics (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeStatistics', params)
  },
  // 增加节点机
  addNode (params) {
    return axios.post('/api/rendering/admin/task/node/addNode', params)
  },
  // 查询节点机相同的属性，要求和群组
  getNodeCommonValue (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeCommonValue', params)
  },
  // 增加，修改，删除节点机属性或者要求
  batchHandleNode (params) {
    return axios.post('/api/rendering/admin/task/node/batchHandleNode', params)
  },
  // 单个节点机重置属性要求，或者群组
  resetSingleNodeValue (params) {
    return axios.post('/api/rendering/admin/task/node/resetSingleNodeValue', params)
  },
  // 获取节点机备注
  getNodeRemark (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeRemark', params)
  },
  /**
   * 修改转测试结束时间
   * @param {String[]} nodeId 节点机ID
   * @param {String} remarkId 备注ID
   * @param {Int} endTime 转测试截止时间
   */
  updateTestEndTime (params) {
    return axios.post('/api/rendering/admin/task/node/updateTestEndTime', params)
  },
  // 重置节点机核数
  resetNodeCore (params) {
    return axios.post('/api/rendering/admin/task/node/resetNodeCore', params)
  },
  // 获取相同备注的节点机
  sameRemarkNode (params) {
    return axios.post('/api/rendering/admin/task/node/sameRemarkNode', params)
  },
  // 解决节点机备注问题
  solveRemarkQuestion (params) {
    return axios.post('/api/rendering/admin/task/node/solveRemarkQuestion', params)
  },
  // 增加节点机备注，暂停，删除，继续节点机
  handleNode (params) {
    return axios.post('/api/rendering/admin/task/node/handleNode', params)
  },
  // 重启节点机
  restartNode (params) {
    return axios.post('/api/rendering/admin/task/node/restartNode', params)
  },
  // 清除IPMI设置
  clearIpmiConfig (params) {
    return axios.post('/api/rendering/admin/task/node/clearIpmiConfig', params)
  },
  // 获取所有平台
  getPlatform (params) {
    return axios.post('/api/rendering/admin/task/node/getPlatform', params)
  },
  // 查询节点机的所有状态
  getNodeAllStatus (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeAllStatus', params)
  },
  // 获取镜像
  getMirrorList (params) {
    return axios.post('/api/rendering/admin/task/node/getSameMirror', params)
  },
  // 获取租赁镜像
  getLeaseMirrorList (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getLeaseSameMirror', params)
  },
  // 切换镜像
  changeMirror (params) {
    return axios.post('/api/rendering/admin/task/node/changeMirror', params)
  },
  // 自动切换镜像
  editAutoChangeSetting (params) {
    return axios.post(' /api/rendering/admin/task/node/mirror/editAutoChangeSetting', params)
  },
  // 查询自动切换镜像设置
  getAutoChangeSetting (params) {
    return axios.post('/api/rendering/admin/task/node/mirror/getAutoChangeSetting', params)
  },
  // 获取系统属性
  getSystemPrperty (params) {
    return axios.post('/api/rendering/admin/task/node/getSysProperties', params)
  },
  // 查询扣费物理核数
  getNodeAllCores (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeAllCores', params)
  },
  /**
   * 转移至租赁节点列表
   * @param {list} nodeids
   */
  moveToRent (params) {
    return axios.post('/api/rendering/admin/task/node/moveRenderNodeToLeaseNew', params)
  },
  /**
   * 获取租赁列表
   * @param {Int} pageNum 每页条数
   * @param {Int} pageSize 当前页
   * @param {Int} [status] 0:空闲，1：离线，2：暂停，3：运行中，4：连接中，5：异常，6：绑定中
   * @param {String} [name] 节点机名
   * @param {String} [ip] ip
   * @param {String} [category] 群组
   * @param {Int} [userId] 用户id
   */
  getRentlist (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getLeaseNodeList', params)
  },
  /**
   * 添加租赁节点机
   * @param {list<object>} node 增加的节点机列表
   * @param {String} name 节点机名
   * @param {Int} [core] 核数
   * @param {String} ip ip
   * @param {String} port 主端口
   * @param {String} aidPort 辅助端口
   * @param {Int} platform 平台号
   */
  addRentNode (params) {
    return axios.post('/api/rendering/admin/task/leasenode/addNodesNew', params)
  },
  /**
   * 删除租赁节点机
   * @param {Array} nodeids 节点机id
   */
  delRentNode (params) {
    return axios.post('/api/rendering/admin/task/leasenode/removeNodeNew', params)
  },
  // 根据添加输入的ip获取租赁节点机的镜像
  getLeaseSameMirrorByIp (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getLeaseSameMirrorByIp', params)
  },
  /**
   * 获取群组
   * @param {*} 无
   */
  queryCategorys (params) {
    return axios.post('/api/rendering/admin/task/leasenode/queryCategorys', params)
  },
  /**
   * 获取要求
   * @param {*} 无
   */
  queryRequirements (params) {
    return axios.post('/api/rendering/admin/task/leasenode/queryRequirements', params)
  },
  /**
   * 添加群组
   * @param {Array} nodeids 节点机id
   * @param {String} category 群组
   */
  addCategory (params) {
    return axios.post('/api/rendering/admin/task/leasenode/addCategory', params)
  },
  /**
   * 释放群组
   * @param {Array} nodeids 节点机id
   */
  deleteCategory (params) {
    return axios.post('/api/rendering/admin/task/leasenode/deleteCategory', params)
  },
  /**
   * 转出至渲染列表
   * @param {Array} nodeids 节点机id
   */
  moveLeaseNodeToRender (params) {
    return axios.post('/api/rendering/admin/task/leasenode/moveLeaseNodeToRenderNew', params)
  },
  // 正式租赁节点转回渲染列表
  moveLeaseNodeToRenderOfficial (params) {
    return axios.post('/api/rendering/admin/task/leasenode/moveLeaseNodeToRender', params)
  },
  /**
   *属性，要求， 群组的修改
   */
  // 获取
  getNodeValues (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeValues', params)
  },
  // 添加
  addNodeValues (params) {
    return axios.post('/api/rendering/admin/task/node/addNodeValues', params)
  },
  // 删除
  delectNodeValues (params) {
    return axios.post('/api/rendering/admin/task/node/delectNodeValues', params)
  },
  // 新增节点机属性/要求有效期记录
  saveNodeValueExpire (params) {
    return axios.post('/api/rendering/admin/task/node/saveNodeValueExpire', params)
  },
  // 删除节点机属性/要求有效期记录
  deleteNodeValueExpire (params) {
    return axios.post('/api/rendering/admin/task/node/deleteNodeValueExpire', params)
  },
  // 查询指定节点机当前有效期内的属性/要求记录
  listNodePropertyExpire (params) {
    return axios.post('/api/rendering/admin/task/node/listNodePropertyExpire', params)
  },
  // 编辑单条有效期记录保留天数
  updateNodeValueExpireDays (params) {
    return axios.post('/api/rendering/admin/task/node/updateNodeValueExpireDays', params)
  },
   // 释放机器
  releaseIdleNode (params) {
    return axios.post('/api/rendering/admin/task/idlenode/releaseIdleNode', params)
  },
  // 查询机器白名单
  queryMachineWhiteList (params) {
    return axios.post('/api/rendering/admin/task/node/queryMachineWhiteList', params)
  },
  // 添加机器白名单
  addMachineWhiteList (params) {
    return axios.post('/api/rendering/admin/task/node/addMachineWhiteList', params)
  },
  // 获取渲染节点机属性，要求，群组
  renderNodeParams () {
    return axios.get('/api/rendering/admin/task/search/renderNodeParams')
  },
  // 指派命令
  postCommand (params) {
    return axios.post('/api/rendering/admin/task/node/postCommand', params)
  },
  // 扣费硬件配置
  hardwareConfigList (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/listAboutTaskHardware', params)
  },
  // 获取硬件配置列表
  getHardwareConfig (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/list', params)
  },
  // 启动/禁用硬件配置
  editHardwareConfigStatus (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/editStatus', params)
  },
  // 增加硬件配置
  addHardwareConfig (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/add', params)
  },
  // 编辑节点机性能参数
  editPerformanceParam (params) {
    return axios.post('/api/rendering/admin/task/node/editPerformanceParam', params)
  },
  // 查询GPU扣费属性
  gpuProperty () {
    return axios.get('/api/rendering/admin/task/hardwareConfig/gpuProperties')
  },
  // 编辑硬件配置支持软件
  modifyConfig (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/modifyConfig', params)
  },
  // 获取硬件型号与性能参数列表
  queryHardwareModelList (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/queryHardwareModeList', params)
  },
  // 获取用户硬件折扣定制
  queryHardwareDiscountList (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/queryHardwareDiscountList', params)
  },
  // 删除硬件折扣
  deleteHardwareDiscount (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/deleteHardwareDiscount', params)
  },
  // 获取硬件型号
  queryDiscountHardwareMode (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/queryDiscountHardwareMode', params)
  },
  // 用户硬件折扣定制-新增，编辑
  addOrEditHardwareDiscount (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/addOrEditHardwareDiscount', params)
  },
  // 新增硬件型号
  addHardwareModel (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/addHardwareMode', params)
  },
  // 修改硬件型号
  updateHardware (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/updateHardwareMode', params)
  },
  // 获取硬件型号
  getHardwareModel () {
    return axios.get('/api/rendering/admin/task/hardwareConfig/getTbTaskHardwareModes')
  },
  // 获取实际型号，CPU，GPU等信息
  getActualCPUAndGPU () {
    return axios.get('/api/rendering/admin/task/node/getActualCPUAndGPU')
  },
  // 获取修改的硬件型号
  getEditTbTaskHardwareModes () {
    return axios.get('/api/rendering/admin/task/hardwareConfig/getEditTbTaskHardwareModes')
  },
  updateHardwareModel (params) {
    return axios.post('/api/rendering/admin/task/node/updateNodeHardwareMode', params)
  },
  // 节点机开机
  powerOnNode (params) {
    return axios.post('/api/rendering/admin/task/node/powerOnNode', params)
  },
  // 节点机关机
  powerOffNode (params) {
    return axios.post('/api/rendering/admin/task/node/powerOffNode', params)
  },
  // 查询自动开机
  queryNodeOnConfig (params) {
    return axios.post('/api/rendering/admin/task/node/queryNodeOnConfig', params)
  },
  // 查询自动开机
  queryNodeOffConfig (params) {
    return axios.post('/api/rendering/admin/task/node/queryNodeOffConfig', params)
  },
  // 自动开机
  changeNodeOnConfig (params) {
    return axios.post('/api/rendering/admin/task/node/changeNodeOnConfig', params)
  },
  // 自动关机
  changeNodeOffConfig (params) {
    return axios.post('/api/rendering/admin/task/node/changeNodeOffConfig', params)
  },
  // ipmi配置
  ipmiConfig (params) {
    return axios.post('/api/rendering/admin/task/node/ipmiConfig', params)
  },
  // /api/rendering/admin/task/hardwareConfig/getHardwareConfigList
  getHardwareConfigList (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/getHardwareConfigList', params)
  },
  // 查询硬件配置操作详情.
  queryOperationDetails (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/queryOperationDetails', params)
  },
  settingStatusShow (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/settingStatusShow', params)
  },
  // 开启镜像限制
  openMirrorLimit (params) {
    return axios.post('/api/rendering/admin/task/node/openMirrorLimit', params)
  },
  // 关闭镜像限制
  closeMirrorLimit (params) {
    return axios.post('/api/rendering/admin/task/node/closeMirrorLimit', params)
  },
  /**
   * 获取转入记录列表
   * @param {Int} pageNum 每页条数
   * @param {Int} pageSize 当前页
   * @param {Int} [status] 准备中、已完成、已关闭
   * @param {String} operateTime 操作时间
   * @param {String} userName 租赁用户名
   */
  getTransferlist (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getTransferRecordList', params)
  },
  // 关闭转入
  closeTransferRecord (params) {
    return axios.post('/api/rendering/admin/task/leasenode/closeTransferRecord', params)
  },
  // 用户是否存在
  existUserByName (params) {
    return axios.post('/api/rendering/admin/front/existUserByName', params)
  },
  // 编辑转入记录
  editTransferRecord (params) {
    return axios.post('/api/rendering/admin/task/leasenode/editTransferRecord', params)
  },
  // 机器详情
  machineDetailsList (params) {
    return axios.post('/api/rendering/admin/task/leasenode/machineDetailsList', params)
  },
  // 转入记录列表统计
  countNum (params) {
    return axios.post('/api/rendering/admin/task/leasenode/countNum', params)
  },
  // 租赁切换镜像
  changeLeaseMirror (params) {
    return axios.post('/api/rendering/admin/task/leasenode/changeLeaseMirror', params)
  },
  // 操作记录
  getOperationRecord (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getOperationRecord', params)
  },
  // 编辑SN编号
  editSnCode (params) {
    return axios.post('/api/rendering/admin/task/node/editSnCode', params)
  },
  // 导入节点机数据
  importAdminNodeData (params) {
    return axios.post('/api/rendering/admin/task/node/importAdminNodeData', params)
  },
  // 编辑租赁SN编号
  editRentSnCode (params) {
    return axios.post('/api/rendering/admin/task/leasenode/editSnCode', params)
  },
  // 导入租赁节点机数据
  importAdminRentNodeData (params) {
    return axios.post('/api/rendering/admin/task/leasenode/importLeaseNodeData', params)
  },
   // 导出节点机数据
  exportNodeData (params) {
    return exportAxios('/api/rendering/admin/task/node/exportNodeData', params)
  },
  // 获取硬件推荐
  getHardwareRecommendation (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/querySuggest', params)
  },
  // 添加硬件推荐配置
  addHardwareRecommendation (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/addSuggest', params)
  },
  // 编辑硬件推荐配置
  editHardwareRecommendation (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/updateSuggest', params)
  },
  // 删除硬件推荐配置
  deleteConfiguration (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/deleteSuggest', params)
  },
  getNodeTaskInfoList(params) {
    return axios.post('/api/rendering/admin/task/node/getNodeTaskInfoList', params)
  },
  // 节点机去重校验
  checkImportNodeData(params) {
    return axios.post('/api/rendering/admin/task/node/checkImportNodeData', params)
  },
  // 获取可以释放的机器数量
  queryReleaseCount(params) {
    return axios.post('/api/rendering/admin/task/idlenode/queryReleaseCount', params)
  },
  // 获取免费渲小样配置信息
  getFreeRenderSampleConfig() {
    return axios.post('/api/rendering/admin/task/common/getFreeRenderSampleConfig')
  },
  // 保存免费渲小样配置信息
  saveFreeRenderSampleConfig(params) {
    return axios.post('/api/rendering/admin/task/common/saveFreeRenderSampleConfig', params)
  },
  // 获取免费渲小样的操作记录
  getFreeRenderSampleConfigRecord(params) {
    return axios.post('/api/rendering/admin/task/common/getFreeRenderSampleConfigRecord', params)
  },
  // 获取自动申请机器比例
  getApplyNodeRate() {
    return axios.post('/api/rendering/admin/task/idlenode/getApplyNodeRate')
  },
  // 设置自动申请机器比例
  setApplyNodeRate(params) {
    return axios.post('/api/rendering/admin/task/idlenode/setApplyNodeRate', params)
  },
  // 获取设置加速比例
  getFastNodeRate() {
    return axios.post('/api/rendering/admin/task/idlenode/getFeeRate')
  },
  // 设置加速比例
  setFastNodeRate(params) {
    return axios.post('/api/rendering/admin/task/idlenode/setFeeRate', params)
  },
  // 释放机器
  releaseNode(params) {
    return axios.post('/api/rendering/admin/task/idlenode/releaseNode', params)
  },
  // 申请机器
  applyNode(params) {
    return axios.post('/api/rendering/admin/task/idlenode/applyNode', params)
  },
  /**
   * 获取申请机器记录
   * {Integer[]} operateTypes 操作类型 0申请机器；1释放机器；2设置比例
   */
  queryNodeOperatorRecord(params) {
    return axios.post('/api/rendering/admin/task/idlenode/queryNodeOperatorRecord', params)
  },
  // 获取线程数
  getThreadsNumber(params) {
    return axios.post('/api/rendering/admin/task/node/getThreadCountList', params)
  },
  // 获取扣费我物理核数
  getObtainNumber(params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/getCores', params)
  },
  // 节点-导出全部数据
  exportNodeAllData(params) {
    return axios.post('/api/rendering/admin/task/node/exportNodeList', params)
  },
  // 节点-错误率清零
  errorRateCleared(params) {
    return axios.post('/api/rendering/admin/task/node/clearStatistic', params)
  },
  queryNodeReleaseRecord() {
    return axios.post('/api/rendering/admin/task/idlenode/queryNodeReleaseRecord')
  },
  // 查询机器模板
  queryCloudTemplate() {
    return axios.post('/api/rendering/admin/task/idlenode/queryCloudTemplate')
  },
  // 编辑机器模板
  editCloudTemplate(params) {
    return axios.post('/api/rendering/admin/task/idlenode/editCloudTemplate', params)
  },
  // 删除机器模板
  delCloudTemplate(params) {
    return axios.post('/api/rendering/admin/task/idlenode/delCloudTemplate', params)
  },
  // 新建cpu5(爱捷云)模板模板
  saveCloudTemplate(params) {
    return axios.post('/api/rendering/admin/task/idlenode/saveCloudTemplate', params)
  },
  // 获取cpu5(爱捷云)模板列表
  queryInstanceTypeList(params) {
    return axios.post('/api/rendering/admin/task/idlenode/queryInstanceTypeList', params)
  },
  // 获取任务分析数据
  getTaskAnalyticsData(params) {
    return axios.post('/api/rendering/admin/task/idlenode/getTaskAnalyticsData', params)
  },
  // 获取任务分析趋势数据
  getTaskAnalyticsTrendData(params) {
    return axios.post('/api/rendering/admin/task/idlenode/getTaskAnalyticsTrendData', params)
  },
  // 普通作业提交设置
  setNormalSubmit(params) {
    return axios.post('/api/rendering/admin/task/idlenode/setNormalSubmit', params)
  },
  // 获取普通作业提交设置
  getNormalSubmit(params) {
    return axios.post('/api/rendering/admin/task/idlenode/getNormalSubmit', params)
  },
  // 获取硬件折扣列表
  queryHardwareDiscountListNew (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/queryBusinessHardwareDiscountList', params)
  },
  // 新增，编辑硬件折扣
  addOrEditBusinessHardwareDiscount (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/addOrEditBusinessHardwareDiscount', params)
  },
  // 获取镜像设置
  getMirrorSettingList(params) {
    return axios.post('/api/rendering/admin/task/node/mirrorConfigList', params)
  },
  // 新增镜像设置
  addMirrorSetting(params) {
    return axios.post('/api/rendering/admin/task/node/addMirrorConfig', params)
  },
  // 编辑镜像设置
  editMirrorSetting(params) {
    return axios.post('/api/rendering/admin/task/node/editMirrorConfig', params)
  },
  // 删除镜像设置
  deleteMirrorSetting(params) {
    return axios.post('/api/rendering/admin/task/node/delMirrorConfig', params)
  },
  // 所有软件字典
  getHardwareConfigurationList(params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/queryCgVersion', params)
  },
  // 获取机器总数
  getActiveNodeCount(params) {
    return axios.post('/api/rendering/admin/task/mirror/getActiveNodeCount', params)
  },
  // 查询镜像配置
  queryMirrorConfigs(params) {
    return axios.post('/api/rendering/admin/task/mirror/queryMirrorConfigs', params)
  },
  // 查询镜像列表
  queryMirrorList(params) {
    return axios.post('/api/rendering/admin/task/node/taskMirrorList', params)
  },
  // 删除镜像配置
  deleteMirrorConfig(params) {
    return axios.post('/api/rendering/admin/task/mirror/deleteMirrorConfig', params)
  },
  // 修改或新增镜像配置
  addOrUpdateMirrorConfig(params) {
    return axios.post('/api/rendering/admin/task/mirror/addOrUpdateMirrorConfig', params)
  },
  // 获取镜像名
  getMirrorName(params) {
    return axios.post('/api/rendering/admin/task/mirror/getMirrorName', params)
  },
  // 查询用户特殊镜像定制列表
  querySpecialUserMirrorList(params) {
    return axios.post('/api/rendering/admin/task/specialUserMirror/list', params)
  },
  // 查询用户特殊镜像定制详情
  getSpecialUserMirrorDetail(params) {
    return axios.post('/api/rendering/admin/task/specialUserMirror/detail', params)
  },
  // 新增用户特殊镜像定制
  addSpecialUserMirror(params) {
    return axios.post('/api/rendering/admin/task/specialUserMirror/add', params)
  },
  // 编辑用户特殊镜像定制
  updateSpecialUserMirror(params) {
    return axios.post('/api/rendering/admin/task/specialUserMirror/update', params)
  },
  // 删除用户特殊镜像定制
  deleteSpecialUserMirror(params) {
    return axios.post('/api/rendering/admin/task/specialUserMirror/delete', params)
  },
  // 启用 / 禁用用户特殊镜像定制（status: 1 启用，0 禁用）
  updateSpecialUserMirrorStatus(params) {
    return axios.post('/api/rendering/admin/task/specialUserMirror/status', params)
  },
  // 获取用户特殊镜像下拉
  getSpecialUserMirrorImageOptions(params) {
    return axios.post('/api/rendering/admin/task/specialUserMirror/imageOptions', params)
  },
  // 获取用户特殊镜像软件下拉
  getSpecialUserMirrorSoftwareOptions(params) {
    return axios.post('/api/rendering/admin/task/specialUserMirror/softwareOptions', params)
  },
  // 获取用户特殊镜像软件版本下拉
  getSpecialUserMirrorSoftwareVersionOptions(params) {
    return axios.post('/api/rendering/admin/task/specialUserMirror/softwareVersionOptions', params)
  },
  // 全局开关设置
  setGlobalConfig(params) {
    return axios.post('/api/rendering/admin/task/mirror/setGlobalConfig', params)
  },
  // 获取全局开关设置
  getGlobalConfig(params) {
    return axios.post('/api/rendering/admin/task/mirror/getGlobalConfig', params)
  },
  getNodeDateDashboard(params) {
    return axios.post('/api/rendering/admin/task/node/getNodeDateDashboard', params)
  },
  checkCloudResource(params) {
    return axios.post('/api/rendering/admin/task/idlenode/checkCloudResource', params)
  },
  /**
   * 创建规格
   * @param {Object} params 参数
   * @param {String} params.specifications 规格
   * @param {String} params.billingMode 扣费模式
   * @param {String} params.nodeProperties 节点机属性
   * @param {String} params.nodeRequirements 节点机要求
   * @param {String} params.model 节点机型号
   * @param {String} params.vrCore 扣费物理核数
   */
  createSpecifications(params) {
    return axios.post('/api/rendering/admin/task/idlenode/createSpecifications', params)
  },
  querySpecifications(params = {}) {
    return axios.post('/api/rendering/admin/task/idlenode/querySpecifications', params)
  },
  /**
   * 更新规格
   * @param {Object} params 参数
   * @param {List<Integer>} params.ids 规格id
   * @param {String} params.specifications 规格
   * @param {String} params.billingMode 扣费模式
   * @param {String} params.nodeProperties 节点机属性
   * @param {String} params.nodeRequirements 节点机要求
   * @param {String} params.model 节点机型号
   * @param {Integer} params.vrCore 扣费物理核数
   */
  updateSpecifications(params) {
    return axios.post('/api/rendering/admin/task/idlenode/updateSpecifications', params)
  },
  /**
   * 删除规格
   * @param {Object} params 参数
   * @param {List<Integer>} params.ids 规格id
   */
  deleteSpecifications(params) {
    return axios.post('/api/rendering/admin/task/idlenode/deleteSpecifications', params)
  },
  /**
   * 创建机器特殊作业要求配置
   * @param {Object} params 参数
   * @param {String} params.specRequirements 特殊作业要求
   * @param {String} params.image 镜像
   * @param {String} params.systemDiskCapacity 系统盘大小
   * @param {String} params.dataDiskCapacity 数据盘大小
   * @param {String} params.remark 备注
   */
  createConfiguration(params) {
    return axios.post('/api/rendering/admin/task/idlenode/createConfiguration', params)
  },
  queryConfiguration(params = {}) {
    return axios.post('/api/rendering/admin/task/idlenode/queryConfiguration', params)
  },
  /**
   * 更新机器特殊作业要求配置
   * @param {Object} params 参数
   * @param {List<Integer>} params.ids 配置id
   * @param {String} params.specRequirements 特殊作业要求
   * @param {String} params.image 镜像
   * @param {String} params.systemDiskCapacity 系统盘大小
   * @param {String} params.dataDiskCapacity 数据盘大小
   * @param {String} params.remark 备注
   */
  updateConfiguration(params) {
    return axios.post('/api/rendering/admin/task/idlenode/updateConfiguration', params)
  },
  /**
   * 删除机器特殊作业要求配置
   * @param {Object} params 参数
   * @param {List<Integer>} params.ids 配置id
   */
  deleteSpecificationsConfiguration(params) {
    return axios.post('/api/rendering/admin/task/idlenode/deleteConfiguration', params)
  },
  getIdlenodeImage() {
    return axios.post('/api/rendering/admin/task/idlenode/getImage')
  },
  queryConfigAndSpec() {
    return axios.post('/api/rendering/admin/task/idlenode/queryConfigAndSpec')
  },
  queryNodeByIp(params) {
    return axios.post('/api/rendering/admin/task/node/queryNodeByIp', params)
  },
  // 查询节点机核对单列表
  queryNodeMachineChecklist(params) {
    return axios.post('/api/rendering/admin/task/nodeCheckList/queryList', params)
  },
  // 导出节点机核对单
  exportNodeMachineChecklist(params) {
    return axios.post('/api/rendering/admin/task/nodeCheckList/export', params)
  },
  // 下载硬件型号匹配表模板
  downloadHardwareModelMappingTemplate() {
    return exportAxios('/api/rendering/admin/task/nodeCheckList/downloadHardwareModelMappingTemplate', {})
  },
  // 全量导入硬件型号匹配关系
  importHardwareModelMappings(params) {
    return axios.post('/api/rendering/admin/task/nodeCheckList/importHardwareModelMappings', params)
  },
  // 获取自动申请机器策略
  queryMachineApplyTimeConfigList() {
    return axios.post('/api/rendering/admin/task/node/machineApplyTimeConfig/list')
  },
  // 设置自动申请机器策略
  setMachineApplyTimeConfig(params) {
    return axios.post('/api/rendering/admin/task/node/machineApplyTimeConfig/save', params)
  },
  // 查询机器规格/模板机器分配设置
  queryMachineDistributeSetting(params) {
    return axios.post('/api/rendering/admin/task/node/machineApplyTimeConfig/template/list', params)
  },
  // 修改机器资源池比例
  updateMachineDistributeSetting(params) {
    return axios.post('/api/rendering/admin/task/node/machineApplyTimeConfig/template/edit', params)
  },
  // 删除机器规格/模板机器分配设置
  deleteMachineApplyTimeConfigTemplate(params) {
    return axios.post('/api/rendering/admin/task/node/machineApplyTimeConfig/template/delete', params)
  },
  /**
   * 正式租赁节点接口。新租赁页面只通过这些入口访问后端，旧入口继续保留给历史页面。
   */
  moveRenderNodeToLease (params) {
    return axios.post('/api/rendering/admin/task/node/moveRenderNodeToLease', params)
  },
  getLeaseNodeList (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getLeaseNodeList', params)
  },
  extendLeaseEndTime (params) {
    return axios.post('/api/rendering/admin/task/leasenode/extendLeaseEndTime', params)
  },
  getLeaseNodeDistributionStatistics (params) {
    return axios.post(
      '/api/rendering/admin/task/leasenode/getLeaseNodeDistributionStatistics',
      params,
      {isCancelRaceApi: true}
    )
  },
  getExpiringLeaseNodeUserList (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getExpiringLeaseNodeUserList', params)
  },
  getThirdLeaseNodeList (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getThirdLeaseNodeList', params)
  },
  getThirdLeaseNodeFilterOptions (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getThirdLeaseNodeFilterOptions', params)
  },
  getThirdLeaseNodeUserDistributionStatistics (params) {
    return axios.post('/api/rendering/admin/task/leasenode/getThirdLeaseNodeUserDistributionStatistics', params)
  },
}
